import React, { FunctionComponent } from 'react';
import { Symbol } from '@doveit/bricks';
import * as styles from './AutocompleteSuggestion.style';

export interface AutocompleteSuggestionProps {
  icon: string,
  label: string,
}

const AutocompleteSuggestion: FunctionComponent<AutocompleteSuggestionProps> = ({
  icon,
  label,
}) => (
  <div css={styles.suggestion}>
    <Symbol path={icon} />
    <span css={styles.suggestionLabel} dangerouslySetInnerHTML={{ __html: label }} />
  </div>
);

export default AutocompleteSuggestion;
